import { useMutation } from '@apollo/client';
import { Form, Formik } from 'formik';
import { get } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import TabLayout from 'routes/Users/components/UsersList/UserDetailDrawer/ClientViewTabs/TabLayout';
import { UPDATE_LOCATION } from 'services/graphql/mutations/location';
import { defaultNotification } from 'utils';
import * as Yup from 'yup';

import { useLocationFormProps, useShippingAccountNoValidateMutation } from '../../LocationForm/hooks';
import LocationFormBasic from '../../LocationForm/LocationFormBasic';
import { ILocationTabDetailProps } from '../types';
import { ILocationDetailReturnShippingValues } from './types';

const LocationDetailReturnShipping: React.FC<ILocationTabDetailProps> = ({ location, refetchLocationData }) => {
  const [loading, setLoading] = useState(false);
  const [updateLocation] = useMutation(UPDATE_LOCATION);
  const { locationReturnShippingInitialValues, locationDocumentShippingReturnFormProps } = useLocationFormProps({
    location,
  });
  // formik ref
  const formikRef = useRef<any>();

  useEffect(() => {
    formikRef.current?.resetForm?.();
  }, [location]);

  const callUpdateLocationMutation = async (v: ILocationDetailReturnShippingValues) => {
    const { fedExAccountNumber } = v;

    try {
      await updateLocation({
        variables: {
          filter: {
            id: location.id,
          },
          updatedDoc: {
            returnShippingAccount: {
              accountNo: fedExAccountNumber,
            },
          },
        },
      });
      defaultNotification({ success: 'Update User Successfully!' });
      refetchLocationData?.();
    } catch (err) {
      defaultNotification({ failure: true });
    } finally {
      setLoading(false);
    }
  };

  const validateShippingAccountNumber = useShippingAccountNoValidateMutation();

  const onSubmit = async (v: ILocationDetailReturnShippingValues) => {
    setLoading(true);
    validateShippingAccountNumber(v.fedExAccountNumber).then((response) => {
      if (!get(response, 'error')) callUpdateLocationMutation(v);
      else {
        setLoading(false);
      }
    });
  };

  return (
    <Formik
      innerRef={formikRef}
      onSubmit={onSubmit}
      validationSchema={Yup.object({
        fedExAccountNumber: Yup.string().notRequired(),
      })}
      initialValues={locationReturnShippingInitialValues}
      enableReinitialize>
      {(props) => (
        <Form className='h-full'>
          <TabLayout loading={loading} onClick={props.handleSubmit}>
            <LocationFormBasic inputProps={locationDocumentShippingReturnFormProps} />
          </TabLayout>
        </Form>
      )}
    </Formik>
  );
};

export default React.memo(LocationDetailReturnShipping);
